import PaymentForm from "../components/PaymentForm"; 
import DepositForm from "../components/Deposit"; 
import PaymentInstruction from "../components/PaymentInstruction"; 
import Footer from "../components/Footer"; 
import {useState} from "react"; 
import SmartsupChat from "../components/SmartsupChat"; 
import DashboardHeader from "../components/DashboardHeader"; 
import {AuthContext} from "../AuthContext"; 
import {useContext} from "react"; 
const DepositPage = ()=>{
  const {user} = useContext(AuthContext); 
  const [amount, setAmount] = useState(""); 
  const updateInstruction = (amount)=>{
	 setAmount(amount); 
  }
  return (
	 <>
		<DashboardHeader userName={user} kycStatus={"Verified"} accountStatus={"Active"} />

		<div className = "grid sm:grid-cols-2 grid-rows-1 items-center justify-center p-[5%]">
		  <PaymentForm updateInstruction = {updateInstruction} />
		  <PaymentInstruction
			 amount = {amount}
			 currency = {"USD"}
		  />
		</div>
		<SmartsupChat />
		<Footer />
	 </>
  ); 
}
export default DepositPage; 
